<template>
  <transition
    v-if="imageUrls.length && imageUrlsToDisplay"
    name="fade"
    mode="out-in"
  >
    <div :key="imageUrlsToDisplay[0]" class="random-image">
      <img
        :key="imageUrlsToDisplay[0]"
        class="main-image"
        :src="getImageUrlWithWidth(imageUrlsToDisplay[0])"
        alt=""
      />
      <div v-if="imageUrlsToDisplay.length > 1" class="additional-images">
        <img
          v-for="image in imageUrlsToDisplay.slice(1)"
          :key="image"
          :src="getImageUrlWithWidth(image)"
          alt=""
        />
      </div>
    </div>
  </transition>
</template>

<script>
import sample from 'lodash.sample';
import SprdImage from 'commons/image/SprdImage.vue';

export default {
  name: 'RandomImage',
  props: {
    imageUrls: {
      type: Array,
      required: true,
    },
    width: {
      type: String,
    },
    intervalTime: {
      type: Number,
      default: 3000,
    },
  },
  comonents: {
    SprdImage,
  },
  data() {
    return {
      imageUrlsToDisplay: null,
      nextImageUrls: null,
      interval: null,
    };
  },
  computed: {
    imageUrlsNotDisplayed() {
      return this.imageUrls.filter(
        (imageUrl) => this.imageUrlsToDisplay !== imageUrl,
      );
    },
  },
  created() {
    this.chooseInitialDisplayedProducts();
  },
  unmounted() {
    clearInterval(this.interval);
  },
  methods: {
    getImageUrlWithWidth(imageUrl) {
      return `${imageUrl}${this.width ? `,width=${this.width},height=${this.width}` : ''}`;
    },
    chooseInitialDisplayedProducts() {
      this.chooseNextImage();

      this.interval = setInterval(() => {
        this.chooseNextImage();
      }, this.intervalTime);
    },
    chooseNextImage() {
      this.imageUrlsToDisplay = this.nextImageUrls || sample(this.imageUrls);
      this.nextImageUrls = sample(this.imageUrlsNotDisplayed);

      // preload next image urls
      this.nextImageUrls.map((url) => {
        const image = new Image();
        image.src = this.getImageUrlWithWidth(url);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.random-image {
  display: flex;
  flex-direction: column;
  height: 100%;

  .main-image {
    flex-grow: 1;
    min-height: 0;
    object-fit: contain;
  }

  .additional-images {
    display: flex;
    justify-content: center;
    gap: 16px;

    img {
      width: 100px;
    }
  }
}
</style>
